export const mockAsyncHttpRequest = async <T>(data: T): Promise<T> => {
  return new Promise((resolve) =>
    // eslint-disable-next-line no-promise-executor-return
    setTimeout(() => {
      resolve(data);
    }, Math.floor(Math.random() * 750))
  );
};
